import { createRoot } from "react-dom/client";
import "./index.css";
import "primeicons/primeicons.css";
import App from "./App.tsx";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./config/authConfig.ts";
import { MsalProvider } from "@azure/msal-react";

const root = createRoot(document.getElementById("root")!);

const msalInstance = new PublicClientApplication(msalConfig);

root.render(
  <MsalProvider instance={msalInstance}>
    <App />
  </MsalProvider>
);
//root.render(<App />);
